/**
 * 销售业绩成本/毛利核算可见角色：超管、管理员、财务
 */
export function canViewSaleCostProfit(userRole) {
  return ['super_admin', 'admin', 'finance'].includes(userRole)
}

export function salePerformanceRecalculateContent() {
  return '套餐底价费用按上架套餐同周期底价计算，卡板底价费用按上架卡板底价乘以数量单独计算。账单-底价差额等于套餐费用减去套餐底价费用，再加上卡板费用减去卡板底价费用。已有同周期底价快照会沿用。计算在后台进行，完成后请刷新页面。'
}
